import { Alert } from 'braid-design-system';
import type { FC, PropsWithChildren } from 'react';

interface Props {}
const ErrorAlert: FC<PropsWithChildren<Props>> = ({ children }) => (
  <Alert tone="critical">{children}</Alert>
);

export default ErrorAlert;
